module.exports = __webpack_public_path__ + "img/pic-weixin.bb0240e6.png";